import { api } from '@scoutus/sports-metrics';
import { AuthTokens, UserProfile } from "../contexts/AuthProvider";

// Types
export interface UpdateProfileRequest {
  first_name?: string;
  last_name?: string;
  profile_image?: string;
}

class AuthService  {
  /**
   * Get user profile information
   * @returns Promise with user profile data
   */
  async getProfile(): Promise<any> {
    return api.users.getUserProfile() as Promise<any>;
  }

   // Storage utilities
  storeTokens(authTokens: AuthTokens):void {
    // Store sensitive tokens in sessionStorage (more secure)
    if (authTokens.accessToken) {
      sessionStorage.setItem('v2_access_token', authTokens.accessToken);
    }
    if (authTokens.expiresAt) {
      sessionStorage.setItem('v2_token_expires_at', authTokens.expiresAt.toString());
    }
  };

  getStoredTokens(): AuthTokens{
    const accessToken = sessionStorage.getItem('v2_access_token');
    const expiresAt = sessionStorage.getItem('v2_token_expires_at');

    return {
      accessToken,
      refreshToken: null,
      expiresAt: expiresAt ? parseInt(expiresAt) : null,
    };
  };

  storeUser(userData: UserProfile){
    // Store user profile in localStorage (less sensitive)
    localStorage.setItem('v2_user_profile', JSON.stringify(userData));
  };

  getStoredUser(): UserProfile | null{
    const userData = localStorage.getItem('v2_user_profile');
    if (userData) {
      try {
        return JSON.parse(userData);
      } catch (error) {
        console.error('Failed to parse stored user data:', error);
        localStorage.removeItem('v2_user_profile');
        return null;
      }
    }
    return null;
  };
  clearAuthState(){


    // Clear storage
    sessionStorage.removeItem('v2_access_token');
    sessionStorage.removeItem('v2_token_expires_at');
    localStorage.removeItem('v2_user_profile');

    // remove the cookies
    document.cookie = 'v2_access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'v2_token_expires_at=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'v2_user_profile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
  };

  getValidToken(): string | null {
    const tokens = this.getStoredTokens();
    if (!tokens.accessToken || this.isTokenExpiredAt(tokens.expiresAt)) {
      return null;
    }
    return tokens.accessToken;
  };
  isTokenExpiredAt(expiresAt: number | null): boolean{
    if (!expiresAt) return true;
    return Date.now() >= expiresAt;
  };
}
const authService = new AuthService();
export default authService;
